import { useEffect, useRef, useState } from "react"
import { api } from "../../function/axios"
import { Subscriber } from "../../store/user/reducer"
import { ChatbotIcon } from "./components/ChatbotIcon"
import { ChatForm } from "./components/ChatForm"
import { ChatMessage } from "./components/ChatMessage"
import "./css/aiassistant.css"
import dashboard_ from '../../sass/dashboard.module.sass'
import { Box, Typography } from '@mui/material'
import { t } from "i18next"

interface Chat {
  role: string;
  text: string;
  type?: string;
  link?: string;
  dateTime?: string;
}

interface Props {
  subscriber: Subscriber
  isMinimized: boolean;
  isMobile: boolean
}

export const AIAssistant = ({ subscriber, isMinimized, isMobile }: Props) => {
  
  const messagesEndRef = useRef<HTMLDivElement>(null)
  
  //messagesEndRef.current?.scrollIntoView({ behavior: "auto" })

  const chatHistory : any = subscriber.chatHistory

  console.log(chatHistory)

  return (
    <>
            <Typography variant="semiBold" fontSize={18}>
        {t('subscriber.usageIrbi')}
      </Typography>
          <Box
        className={dashboard_.card_column}>

<div className="container">
      <div className={`chatbot-popup ${isMinimized ? 'minimized' : ''} ${isMobile ? 'mobile' : ''}`}>
        <div className="chat-header">
          <div className="header-info">
            <ChatbotIcon />
            <h2 className="logo-text">iRBI history</h2>
          </div>
        </div>
        {/*Chat Body*/}
        <div className="chat-body">
          <div className="message bot-message">
            <ChatbotIcon />
            <p className="message-text">No messages in chat yet</p>
          </div>

          {chatHistory && chatHistory.data && Array.isArray(chatHistory.data) && chatHistory.data.map((chat: any, index: number) => (
            <ChatMessage key={index} chat={chat} />
          ))}
          <div ref={messagesEndRef} />
        </div>
      </div>
    </div>
        </Box>
        
    </>
    
  )
}